/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Card from "../Card";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Icon from "../Icon";

class LifecycleDashChecklist extends BaseCom {
    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Checklist</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul>
                    {this.state.checklist?.map(i => <li key={i.id}>{i.name}</li>)}
                </ul>
            </Modal.Body>
        </Modal>;
    }
}

class LifecycleDash extends BaseCom {
    componentDidMount() {
        qreq.get('/api/phase/list/total', j => {
            if (j.list)
                this.setState({ phases: j.list })
        });
    }

    render() {
        return <div className="LifecycleDash container-fluid">
            <div className="d-flex justify-content-evenly align-items-stretch gap-1 overflow-x-auto">
                {this.state.phases?.map(i => <div key={i.id} className="text-center d-flex align-items-stretch">
                    <Card className="lifecycle-pill flex-fill --bg-primary" onClick={() => i.isFinal ? this.props.navigate('/order/discharge') : this.props.navigate('/order/filter/' + window.btoa(JSON.stringify({ PhaseID: String(i.id) })))}>
                        <div className="lifecycle-name">{i.name}</div>
                        <h4 style={{ color: i.color }}>{i.totalCount}</h4>
                    </Card>
                </div>)}
            </div>
            <div className="d-block d-md-none text-center"><i><Icon icon="faLeftRight" /> Scroll horizontally to view all data.</i></div>
        </div>;
    }
}

export default withParamsAndNavigate(LifecycleDash);